import { useMutation } from '@tanstack/react-query';
import { useParticipantsPersonEventsApi } from 'services';

export const useCreatePerson = () => {
  const { createPerson } = useParticipantsPersonEventsApi();

  return useMutation({ mutationFn: createPerson });
};
